'use strict'

import hljs from 'highlight.js/lib/highlight'
import json from 'highlight.js/lib/languages/json'
import javascript from 'highlight.js/lib/languages/javascript'
import xml from 'highlight.js/lib/languages/xml'

hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('json', json)
hljs.registerLanguage('xml', xml)

function highlight(el, binding) {
  el.textContent = binding.value.code
  hljs.highlightBlock(el)
}

export default {
  install(vue) {
    vue.directive('highlightjs', {
      deep: true,

      bind(el, binding) {
        highlight(el, binding)
      },

      componentUpdated(el, binding) {
        if (
          binding.oldValue.code === binding.value.code &&
          binding.oldValue.language === binding.value.language
        ) {
          return
        }

        highlight(el, binding)
      },
    })
  },
}
